<script lang="ts">
  import { push } from 'svelte-spa-router';
  import Table from '../../Table.svelte';
  import type { RecentPendingPayment } from '../../../lib/api/employer';
  import { formatDate } from '../../../lib/utils/formatters';

  export let payments: RecentPendingPayment[] = [];
  export let loading = false;
  export let error: string | null = null;

  const columns = [
    {
      key: 'employee_name',
      label: 'Employee',
      width: '30%',
      mobilePrimary: true,
      render: (value: string) => `<span class="employee-name">${value}</span>`
    },
    {
      key: 'charity_name',
      label: 'Charity',
      width: '30%',
      render: (value: string) => `<span class="charity-name">${value}</span>`
    },
    {
      key: 'amount',
      label: 'Amount',
      width: '20%',
      render: (value: number) =>
        `<span class="amount-value">${formatCurrency(value)}</span>`
    },
    {
      key: 'approved_at',
      label: 'Approved',
      width: '20%',
      render: (value: string | null) =>
        `<span class="date-value">${value ? formatDate(value) : 'N/A'}</span>`
    }
  ];

  function formatCurrency(amount: number): string {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(amount);
  }

  function handleRowClick(row: RecentPendingPayment) {
    if (row?.uuid) {
      push(`/view-leave-request?id=${row.uuid}`);
    }
  }
</script>

{#if loading}
  <div class="loading-container">
    <div class="loading-spinner"></div>
    <p>Loading pending payments...</p>
  </div>
{:else if error}
  <div class="error-container">
    <p class="error-message">{error}</p>
  </div>
{:else}
  <Table
    actionText="View All"
    actionHref="#/employer/outstanding-invoices"
    {columns}
    data={payments}
    onRowClick={handleRowClick}
  />
{/if}

<style>
  .loading-container,
  .error-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 3rem;
    text-align: center;
    background: white;
    border-radius: 12px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  }

  .loading-spinner {
    width: 2rem;
    height: 2rem;
    border: 3px solid #f3f4f6;
    border-top: 3px solid #f0b429;
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin-bottom: 1rem;
  }

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }

  .error-message {
    color: #dc2626;
    font-size: 1.1rem;
  }

  :global(.employee-name),
  :global(.charity-name) {
    font-weight: 500;
    color: #111827;
  }

  :global(.amount-value) {
    font-weight: 600;
    color: #111827;
  }

  :global(.date-value) {
    color: #6b7280;
  }
</style>
